module.exports = __webpack_public_path__ + "img/assertiveness_thinkPositive.9ff2e25e.png";